export const DEFAULT_LANG = 'en';
export const SUPPORTED_LANGS = ['en', 'ru', 'es', 'de', 'pt', 'fr'] as const;

const LANG_RE = /^\/(ru|es|de|pt|fr)(\/|$)(.*)/;

/** Extract language and clean path from a pathname like `/ru/about`. */
export function parseLangPath(pathname: string): { lang: string; path: string } {
  const match = LANG_RE.exec(pathname);
  if (match) {
    const rest = match[3] || '';
    return { lang: match[1]!, path: '/' + rest };
  }
  return { lang: DEFAULT_LANG, path: pathname };
}

/** Build a language-prefixed path: `langPath('ru', '/about')` → `/ru/about`. */
export function langPath(lang: string, path: string): string {
  if (lang === DEFAULT_LANG) return path;
  return `/${lang}${path === '/' ? '' : path}`;
}

const SUMMARY_LANG_RE = /\/summary\/([a-z]{2})(?:\/|$)/;

/**
 * Extract summary content language from URL path.
 * `/summary/ru/tag/foo` → `'ru'`, `/summary/` → `null`.
 * Matches any 2-letter code (safe because videoIds are 11 chars).
 */
export function parseSummaryLang(pathname: string): string | null {
  const clean = parseLangPath(pathname).path;
  const match = SUMMARY_LANG_RE.exec(clean);
  return match ? match[1]! : null;
}
